import React from 'react';
import { Link } from 'react-router-dom';
import servicesData from '../../../data/services-data';
import serviceDetailsData from '../../../data/service-details-data';
import ctaImage from '../../../assets/img/service-details/cta.jpg';

// Import service detail images
import newBuildMain from '../../../assets/img/service-details/New Build Main.png';
import newBuild1 from '../../../assets/img/service-details/New build 1.png';
import newBuild2 from '../../../assets/img/service-details/New Build 2.png';
import landscapeMain from '../../../assets/img/service-details/Landscape Main.png';
import landscape1 from '../../../assets/img/service-details/Landscape 1.png';
import landscape2 from '../../../assets/img/service-details/Landscape 2.png';
import extensionMain from '../../../assets/img/service-details/Extention Main.png';
import extension1 from '../../../assets/img/service-details/Extension 1.png';
import extension2 from '../../../assets/img/service-details/Extension 2.png';
import bathroomMain from '../../../assets/img/service-details/Bathroom Main.png';
import bathroom1 from '../../../assets/img/service-details/Bathroom 1.png';
import bathroom2 from '../../../assets/img/service-details/Bathroom 2.png';
import loftMain from '../../../assets/img/service-details/Loft Conversion Main.png';
import loft1 from '../../../assets/img/service-details/Loft conversion 1.png';
import loft2 from '../../../assets/img/service-details/Loft conversion 2.png';
import kitchenMain from '../../../assets/img/service-details/Kitchen Main.png';
import kitchen1 from '../../../assets/img/service-details/Kitchen 1.png';
import kitchen2 from '../../../assets/img/service-details/Kitchen 2.png';
import decorationMain from '../../../assets/img/service-details/Decoration Main.png';
import decoration1 from '../../../assets/img/service-details/Decoration 1.png';
import decoration2 from '../../../assets/img/service-details/Decoration 2.png';
import plumbingMain from '../../../assets/img/service-details/Plumbing Main.png';
import plumbing1 from '../../../assets/img/service-details/Plumbing 1.png';
import plumbing2 from '../../../assets/img/service-details/Plumbing 2.png';
import refurbishMain from '../../../assets/img/service-details/Refurbish Main.png';
import refurbish1 from '../../../assets/img/service-details/Refurbish 1.png';
import refurbish2 from '../../../assets/img/service-details/Refurbish 2.png';
import electricityMain from '../../../assets/img/service-details/Electricity Main.png';
import electric1 from '../../../assets/img/service-details/Electric 1.png';
import electric2 from '../../../assets/img/service-details/Electric 2.png';
import renovationMain from '../../../assets/img/service-details/Renovation Main.png';
import renovation1 from '../../../assets/img/service-details/Renovation 1.png';
import renovation2 from '../../../assets/img/service-details/Renovation 2.png';
import interiorMain from '../../../assets/img/service-details/Interior Main.png';
import interior1 from '../../../assets/img/service-details/Interior 1.png';
import interior2 from '../../../assets/img/service-details/Interior 2.png';

// Mapping service IDs to their corresponding images
const serviceImages = {
    'new-builds': {
        main: newBuildMain,
        image1: newBuild1,
        image2: newBuild2
    },
    'landscaping': {
        main: landscapeMain,
        image1: landscape1,
        image2: landscape2
    },
    'extensions': {
        main: extensionMain,
        image1: extension1,
        image2: extension2
    },
    'bathroom-fittings': {
        main: bathroomMain,
        image1: bathroom1,
        image2: bathroom2
    },
    'loft-conversions': {
        main: loftMain,
        image1: loft1,
        image2: loft2
    },
    'kitchen-fittings': {
        main: kitchenMain,
        image1: kitchen1,
        image2: kitchen2
    },
    'decorating': {
        main: decorationMain,
        image1: decoration1,
        image2: decoration2
    },
    'plumbing-works': {
        main: plumbingMain,
        image1: plumbing1,
        image2: plumbing2
    },
    'refurbishment': {
        main: refurbishMain,
        image1: refurbish1,
        image2: refurbish2
    },
    'electrical-works': {
        main: electricityMain,
        image1: electric1,
        image2: electric2
    },
    'renovation': {
        main: renovationMain,
        image1: renovation1,
        image2: renovation2
    },
    'interior-design': {
        main: interiorMain,
        image1: interior1,
        image2: interior2
    }
};

const ServicesSingleMain = ({singleData}) => {
    const serviceDetails = serviceDetailsData[singleData.id] || {};
    const images = serviceImages[singleData.id] || {};
    const mainImage = images.main || singleData.image;
    const detailImage1 = images.image1 || singleData.image;
    const detailImage2 = images.image2 || singleData.image;
    
    return (
        <>
            <div className="services__details section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 columns_sticky">
                            <div className="all__sidebar">                        
                                <div className="all__sidebar-item">
                                    <h4>Our Solutions</h4>
                                    <div className="all__sidebar-item-category">
                                        <ul>
                                            {servicesData.map((data, id) => (
                                                <li key={id}><Link to={`/services/${data.id}`}>{data.title}<i className="flaticon-right-up"></i></Link></li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="all__sidebar-item-help mb-25" style={{backgroundImage: `url(${ctaImage})`}}>
                                    <h3>Ready for Your Next Construction?</h3>
                                    <Link className="build_button mt-20" to="/contact-us">Get an Advice<i className="flaticon-right-up"></i></Link>
                                </div>
                            </div>  
                        </div>
                        <div className="col-lg-8">
                            <div className="services__details-area">
                                <img src={mainImage} alt={singleData.title} />
                                <h3 className="mt-25 mb-20">{singleData.title}</h3>
                                <p className="mb-20">{singleData.description}</p>
                                <p className="mb-25">{serviceDetails.detailedDescription || 'At Sukhi Construction Ltd, we bring years of industry experience to every project. Our team of skilled professionals handles every aspect of the construction process, ensuring your project runs smoothly and efficiently. We prioritize open communication, timely delivery, and quality workmanship to exceed your expectations.'}</p>
                                <h4 className="mb-20">{serviceDetails.whyChooseUs || `Why Choose Us for ${singleData.title}?`}</h4>
                                <p>{serviceDetails.whyChooseUsContent || `We deliver exceptional ${singleData.title.toLowerCase()} services backed by years of experience. Our skilled team prioritizes quality, transparency, and client satisfaction. We utilize innovative techniques and sustainable practices, ensuring timely project completion. Trust us to bring your vision to life with unmatched craftsmanship and attention to detail.`}</p>
                                <div className="row mt-40 mb-40">
                                    <div className="col-sm-6 sm-mb-25">
                                        <img className="img_full" src={detailImage1} alt={singleData.title} />
                                    </div>
                                    <div className="col-sm-6">
                                        <img className="img_full" src={detailImage2} alt={singleData.title} />
                                    </div>
                                </div>
                                <p>Our commitment to excellence means we work closely with you throughout the entire process, from initial consultation to final completion. We understand that every project is unique, and we tailor our approach to meet your specific needs and budget requirements.</p>
                                {serviceDetails.features && serviceDetails.features.length > 0 && (
                                    <ul className="services__details-area-list">
                                        {serviceDetails.features.map((feature, index) => (
                                            <li key={index}><i className="flaticon-check-mark"></i>{feature}</li>
                                        ))}
                                    </ul>
                                )}
                                <h3>Commonly Asked Questions</h3>
                                <div className="mt-30" id="accordionExample">
                                    {serviceDetails.faq && serviceDetails.faq.length > 0 ? (
                                        serviceDetails.faq.map((faqItem, index) => (
                                            <div key={index} className="faq-item">
                                                <h5 className={`icon ${index === 0 ? '' : 'collapsed'}`} data-bs-toggle="collapse" data-bs-target={`#collapse${index + 1}`}>
                                                    {index + 1}. {faqItem.question}
                                                </h5>
                                                <div id={`collapse${index + 1}`} className={`faq-item-body collapse ${index === 0 ? 'show' : ''}`} data-bs-parent="#accordionExample">
                                                    <p>{faqItem.answer}</p>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <>
                                            <div className="faq-item">
                                                <h5 className="icon" data-bs-toggle="collapse" data-bs-target="#collapseOne">1. What services do you offer?</h5>
                                                <div id="collapseOne" className="faq-item-body collapse show" data-bs-parent="#accordionExample">
                                                    <p>We offer a range of services including construction management, design-build solutions, renovations, and specialty contracting for both residential and commercial projects</p>
                                                </div>
                                            </div>
                                            <div className="faq-item">
                                                <h5 className="icon collapsed" data-bs-toggle="collapse" data-bs-target="#collapseTwo">2. Do you provide free estimates?</h5>
                                                <div id="collapseTwo" className="faq-item-body collapse" data-bs-parent="#accordionExample">
                                                    <p>Yes, we offer free estimates for all potential projects. We assess your requirements and provide a detailed quote without any obligation</p>
                                                </div>
                                            </div>
                                            <div className="faq-item">
                                                <h5 className="icon collapsed" data-bs-toggle="collapse" data-bs-target="#collapseThree">3. Are you licensed and insured?</h5>
                                                <div id="collapseThree" className="faq-item-body collapse" data-bs-parent="#accordionExample">
                                                    <p>Yes, we are fully licensed and insured to operate in our service areas. This ensures that your project is protected and complies with all local regulations</p>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>          
        </>
    );
};

export default ServicesSingleMain;